import { render } from "./ChartSimpleDonut.vue?vue&type=template&id=1e22e81d&scoped=true"
import script from "./ChartSimpleDonut.vue?vue&type=script&lang=js"
export * from "./ChartSimpleDonut.vue?vue&type=script&lang=js"

import "./ChartSimpleDonut.vue?vue&type=style&index=0&id=1e22e81d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e22e81d"]])

export default __exports__